// lib/feedback.ts

import { toast } from "@/components/ui/toast";
import { CircleCheck, TriangleAlert } from "lucide-react";

export type FeedbackTarget = 'app_ux' | 'search_result' | 'ai_summary' | 'ai_tag' | 'document_content' | 'paragraph_content';

interface FeedbackParams {
  targetType: FeedbackTarget;
  targetId?: string | number | null;
  isPositive?: boolean | null;
  labels?: string[];
  text?: string;
}

export async function submitFeedback({
  targetType,
  targetId = null,
  isPositive = null,
  labels = [],
  text = ""
}: FeedbackParams) {
  try {

    toast({
      text: "Thanks for helping us improve!",
      icon: CircleCheck,
    });
    
    const response = await fetch("/api/feedback", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ 
        targetType, 
        targetId, 
        isPositive: isPositive ?? null, 
        labels, 
        text 
      }),
    });

    if (!response.ok) throw new Error("Failed to send feedback");

    return { success: true };
  } catch (error) {
    toast({
      text: "Could not save feedback!",
      icon: TriangleAlert,
    });
    return { success: false };
  }
}
